import React, { ComponentProps, useEffect, useTransition } from 'react'

import Link from 'next/link'

import { useGlobalLoading } from 'src/hooks'

type Props = ComponentProps<typeof Link> & {
  /** グローバルローディングを表示し続け遷移先のページ側で制御する場合true */
  isKeepLoading?: boolean
}

/** クリック時にグローバルローディングを表示するLinkコンポーネント */
export function GlobalLoadingLink({ href, onClick, isKeepLoading, ...otherProps }: Props) {
  const { showGlobalLoading, hideGlobalLoading } = useGlobalLoading()

  const [isPending, startTransition] = useTransition()

  // URLが変更された際に実行される処理。グローバルローディングを非表示にする
  useEffect(() => {
    if (isKeepLoading) {
      return
    }

    if (!isPending) {
      hideGlobalLoading()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPending])

  const handleOnClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    showGlobalLoading()

    // useTransition のハック
    // ページ遷移に伴いレンダリングが開始され isPending が true になり、ページ遷移後レンダリングが完了すると false になる
    startTransition(() => {})
    onClick?.(event)
  }

  return <Link {...otherProps} href={href} onClick={handleOnClick} />
}
